import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  Heading,
  Text,
  Stack,
  Divider,
  Grid,
  GridItem,
  useBreakpointValue,
  Image,
  useToast
} from '@chakra-ui/react';
import InvoiceDownload from '../../OrderSummaryPage/InvoiceDownload';
import back from '../../../assets/icons/backArrow.png';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const OrderInfo = ({ order, onClose, onUpdateShippingStatus }) => {
  const toast = useToast();
  const navigate = useNavigate();
  const [shippingStatus, setShippingStatus] = useState("");
  const [courierService, setCourierService] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [trackingId, setTrackingId] = useState(order?.shipping?.tracking_id || "");
  const [invoiceData, setInvoiceData] = useState(null);
  const products = order.products;
  const totalAmount = products.reduce((sum, product) => sum + (product.pricePerUnit || 0) * (product.quantity || 0), 0);
  const totalDiscount = products.reduce((sum, product) => sum + ((product.discountPerUnit || 0) / 100) * (product.pricePerUnit || 0) * (product.quantity || 0), 0);
  const totalPayable = totalAmount - totalDiscount + 40;

  const orderId = order.orderId;
  const mihpayid = order.mihpayid;
  const updatedAt = order.updatedAt;
  const shippingDetails = {
    "first_name": order.shipping.firstName,
    "last_name": order.shipping.lastName,
    "phone": order.shipping.phone,
    "address": order.shipping.address,
  };

  useEffect(() => {
    if (order) {
      setShippingStatus(order.shipping.status || "Processing");
      setCourierService(order.shipping.courier_service || "none");
      setTrackingId(order.shipping.tracking_id || "");
      // console.log(order);
    }
  }, [order]);

  // useEffect(()=>{
  //   console.log(isEditing);
  // }, [isEditing])

  // Set the data for the invoice
  useEffect(() => {
    setInvoiceData({
      orderId,
      mihpayid,
      updatedAt,
      shippingDetails,
      products,
      totalAmount,
      totalDiscount,
      totalPayable,
    });
  }, []);

  // Handle dropdown change
  const handleStatusChange = (event) => {
    setShippingStatus(event.target.value);
  };

  const handleCourierService = (event) => {
    setCourierService(event.target.value);
  };


  const handleTrackingId = (event) => {
    setTrackingId(event.target.value);
  };

  // Handle Save Button
  const handleSave = async () => {
    try {
      const body = {
        "_id": order._id,
        "status": shippingStatus,
        "courier_service": courierService,
        "tracking_id": trackingId
      };
      // console.log("body", body);

      const response = await axios.post("https://leatherandstyle.netlify.app/.netlify/functions/updateOrder", body);

      if (response.status == 200) {
        // console.log("Order updated successfully");
        toast({
          title: "Order Updated Successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
          position: "top-right"
        });

        onClose();
      }
    } catch (e) {
      console.log("err in updating the order", e);
      toast({
        title: "Error Updating Order",
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right"
      });
    }
  };

  // Responsive layout based on screen size
  const gridTemplateColumns = useBreakpointValue({ base: '1fr', md: 'repeat(2, 1fr)' });

  return (
    <Box p={6} borderWidth={1} borderRadius="lg" boxShadow="md" mx="auto" width="90%">
      <VStack align="start" spacing={4}>
        <Button style={{ backgroundColor: "transparent", width: "4.4rem" }} onClick={onClose}>
          <img src={back} alt="" />
        </Button>
        {/* Heading */}
        <Heading size="lg" mb={4}>
          Order Details
        </Heading>

        {/* Profile Data */}
        <Box width="100%">
          <Heading size="md" mb={4} mt={4} textAlign="left">
            Profile Data
          </Heading>
          <Grid templateColumns={gridTemplateColumns} gap={4}>
            <GridItem>
              <FormControl>
                <FormLabel>Full Name</FormLabel>
                <Input value={`${order.profile_data.first_name || ''} ${order.profile_data.last_name}`} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input value={order.profile_data.email} isReadOnly />
              </FormControl>
            </GridItem>
          </Grid>
        </Box>

        <Divider />

        {/* Shipping Data */}
        <Box width="100%">
          <Heading size="md" mb={4} mt={4}  textAlign="left">
            Shipping Data
          </Heading>
          <Grid templateColumns={gridTemplateColumns} gap={4}>
            <GridItem>
              <FormControl>
                <FormLabel>First Name</FormLabel>
                <Input value={order.shipping.firstName} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Last Name</FormLabel>
                <Input value={order.shipping.lastName} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Phone</FormLabel>
                <Input value={order.shipping.phone} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Address</FormLabel>
                <Input value={order.shipping.address} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Pincode</FormLabel>
                <Input value={order.shipping.pincode} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Locality</FormLabel>
                <Input value={order.shipping.locality} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>City</FormLabel>
                <Input value={order.shipping.city} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>State</FormLabel>
                <Input value={order.shipping.state} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Landmark</FormLabel>
                <Input value={order.shipping.landmark} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
             
            </GridItem>
            {/* Status and Courier Service */}
            <GridItem>
              <FormControl>
                <FormLabel>Status</FormLabel>
                {isEditing ? (
                  <Select value={shippingStatus} onChange={handleStatusChange}>
                    <option value="processing">Processing</option>
                    <option value="couriered">Couriered</option>
                    <option value="returned">Returned</option>
                    <option value="cancelled">Cancelled</option>
                  </Select>
                ) : (
                  <Input value={shippingStatus} isReadOnly />
                )}
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Courier Service</FormLabel>
                {isEditing ? (
                  <Select value={courierService} onChange={handleCourierService}>
                    <option value="none">None</option>
                    <option value="maruti">Maruti</option>
                    <option value="dtdc">DTDC</option>
                    <option value="bluedart">Bluedart</option>
                  </Select>
                ) : (
                  <Input value={courierService} isReadOnly />
                )}
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Tracking Id</FormLabel>
                {isEditing ? (
                  <Input value={trackingId} onChange={handleTrackingId} />
                ) : (
                  <Input value={trackingId} isReadOnly />
                )}
                
              </FormControl>
            </GridItem>
          </Grid>
          {/* Edit Button */}
          <Grid style={{ marginTop: "1rem" }}>
            <GridItem>
              {
                isEditing? (
                  <>
                     <Button colorScheme="blue" onClick={() => setIsEditing(false)}>
                      Save
                    </Button>
                  </>
                ) : (
                  <Button colorScheme="blue" onClick={() => setIsEditing(true)}>
                    Edit Status and Courier Service
                  </Button>
                )
              }
              
            </GridItem>
           
          </Grid>
        </Box>

        <Divider />

        {/* Payment Data */}
        <Box width="100%">
          <Heading size="md" mb={4} mt={4}  textAlign="left">
            Payment Data
          </Heading>
          <Grid templateColumns={gridTemplateColumns} gap={4}>
            <GridItem>
              <FormControl>
                <FormLabel>Amount</FormLabel>
                <Input value={`₹ ${order.payment.amount}`} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Transaction Id</FormLabel>
                <Input value={order.payment.transactionId || 'N/A'} isReadOnly />
              </FormControl>
            </GridItem>
            <GridItem>
              <FormControl>
                <FormLabel>Payment Status</FormLabel>
                <Input value={order.payment.paymentStatus} isReadOnly />
              </FormControl>
            </GridItem>
          </Grid>
        </Box>

        <Divider />

        {/* Products Data */}
        <Box width="100%">
          <Heading size="md" mb={4} mt={4}  textAlign="left">
            Products
          </Heading>
          {order.products.map((product, index) => (
            <Box
              key={product.id || index}
              display="flex"
              alignItems="center"
              borderWidth={1}
              borderRadius="md"
              p={3}
              mb={4}
              boxShadow="sm"
              bg="gray.50"
              _hover={{ boxShadow: 'md' }}
            >
              {/* Image Box */}
              <Box
                flexShrink={0}
                mr={4}
                borderRadius="md"
                overflow="hidden"
                boxSize="80px"
              >
                <Image
                  src={product.image}
                  alt={product.name}
                  boxSize="80px"
                  objectFit="cover"
                  borderRadius="md"
                />
              </Box>

              {/* Product Details */}
              <Box flex="1" style={{ textAlign: "left" }}>
                <Text fontSize="md"><b>Name:</b> {product.name}</Text>
                <Text fontSize="md"><b>Quantity:</b> {product.quantity}</Text>
                <Text fontSize="md"><b>Price Per Unit:</b> ₹ {product.pricePerUnit}</Text>
                <Text fontSize="md"><b>Discount Per Unit:</b> {product.discountPerUnit} %</Text>
                <Text fontSize="md"><b>Total:</b> ₹ {product.total}</Text>
              </Box>
            </Box>
          ))}
        </Box>

        <Box width="100%">
          <InvoiceDownload invoiceData={invoiceData} />
        </Box>

        {/* Actions */}
        <Stack direction="row" spacing={4} mt={4}>
          <Button colorScheme="blue" onClick={handleSave}>
            Save
          </Button>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </Stack>
      </VStack>
    </Box>
  );
};

export default OrderInfo;

